export const COLORS = {
  WHITE: '#ffffff',
  SILVER_CHALICE: '#ACAEA9',
  CRIMSON: '#ED1B2E',
  EMPEROR: '#4F4F4F',
  DODGER_BLUE: '#1EA5FC',
  WILD_SAND: '#F4F4F4',
  ROLLING_STONE: '#70777E'
}
